import * as yup from 'yup'

export const autocompleteValidationSchema = yup.object({
  state: yup.string().required('Select your state to proceed.'),
  insurance: yup.string().required('Select your insurance to proceed.'),
  email: yup
    .string()
    .email()
    .when('$experimentGroup', ([experimentGroup], schema) => {
      if (experimentGroup === 'required') {
        return schema.required(
          "Email is required. Don't worry—spam is not our thing!"
        )
      }
      return schema
    }),
})

export const processInsuranceStates = (
  insuranceCatalog: APIResponse.InsuranceCatalog[]
) => insuranceCatalog?.map(({ stateName }) => stateName) || []

const byPromoted = ({ promoted }: APIResponse.Insurance) => promoted
const byEligibility = ({ eligible }: APIResponse.Insurance) => eligible
const byCompanyAsc = (a: APIResponse.Insurance, b: APIResponse.Insurance) => {
  if (a.company < b.company) {
    return -1
  }

  if (a.company > b.company) {
    return 1
  }

  return 0
}

export const findInsuranceProviders = (
  stateName: string,
  stateInsurancesCatalog: APIResponse.InsuranceCatalog[]
) => {
  const carriers = stateInsurancesCatalog
    .filter((insuranceCatalog) => insuranceCatalog.stateName === stateName)
    .pop()
  const eligibleInsurancesAsc = carriers?.insurances
    .filter(byEligibility)
    .sort(byCompanyAsc)
  const eligiblePromotedInsurancesAsc =
    eligibleInsurancesAsc?.filter(byPromoted)
  return {
    allInsurances: eligibleInsurancesAsc || [],
    promotedInsurances: eligiblePromotedInsurancesAsc || [],
  }
}
